<template>
  <Puzzle v-if="currentPuzzle && currentPuzzle.id"/>

  <div v-else>
    Loading...
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import {
    GET_PUBLISHED_PUZZLE,
    GET_PUZZLE_BY_ID,
  } from '@/utils/graphql'

  import Puzzle from '@/components/puzzle/Puzzle'

  export default {
    name: 'PuzzleDetail',

    // beforeMount () {
    //   this.$store.dispatch('getJson', { filename: 'puzzle' })
    //     .then((puzzle) => {
    //       this.$store.dispatch('initiatePuzzle', { puzzle })
    //
    //       if (this.$route.query.reset) {
    //         this.$store.dispatch('resetPuzzle')
    //       }
    //     })
    // },

    watch: {
      $route: {
        handler: function (newValue) {
          this.$store.commit('setCurrentPuzzle', { puzzle: null })
        },
        immediate: true
      },

      publishedPuzzle: function (newValue) {
        this.$store.dispatch('initiatePuzzle', { puzzle: newValue })

        if (this.$route.query.reset) {
          this.$store.dispatch('resetPuzzle')
        }
      }
    },

    computed: {
      ...mapState({
        currentPuzzle: state => state.currentPuzzle
      }),

      id() {
        return this.$route.params.id
      }
    },

    // Apollo-specific options
    apollo: {
      // Advanced query with parameters
      // The 'variables' method is watched by vue
      publishedPuzzle: {
        query() {
          const id = this.$route.params.id
          return id ? GET_PUZZLE_BY_ID : GET_PUBLISHED_PUZZLE
        },
        variables() {
          let variables = {}

          const id = this.$route.params.id
          if (id) {
            variables.id = parseInt(id)
          }

          return variables
        },
        error() {
          this.$router.push({ name: 'NotFound' })
        },
        // Variables: deep object watch
        deep: false,
        fetchPolicy: 'no-cache',
        // We use a custom update callback because
        // the field names don't match
        update: data => data.published_puzzle || data.puzzle
      }
    },

    components: {
      Puzzle
    }
  }
</script>
